import React, { useEffect, useState } from "react"
import Select from "./Select"
import {addMonths, subMonths, format, startOfMonth, endOfMonth} from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { Grid } from "@material-ui/core"
import { useTranslation } from "react-i18next"
import DateField from '../../components/Form/Date'

type Props = any;

const SelectDate: React.FC<Props> = ({ disabled, name, control, multiple, style, label, setValue, enablePeriod=false, dateAndTime= false}) => {
  const [list, setList] = useState<any>([])
  const { t: tGeneral } = useTranslation("General")
  
  useEffect(() => {
    let dateInit = subMonths(new Date(), 7);

    let months:any[] = [];
    for (let i = 0; i < 18; i++) {
      dateInit = addMonths(dateInit, 1)
      months.push({
        label: format(dateInit, 'LLLL', { locale: ptBR }) + '/' + dateInit.getUTCFullYear(), 
        code: format(dateInit, 'LLLL', { locale: ptBR }) + '/' + dateInit.getUTCFullYear(),
        month: (dateInit.getUTCMonth()+1).toString(),
        startMonth: startOfMonth(dateInit),
        endMonth: endOfMonth(dateInit),
      })
      setList(months);
    }

    setValue(name, months[6]);
    onChangeRef(months[6]);

  }, []);

  const onChangeRef = (data: any) => {
    if(data == null) {
      setValue(name, {});
      setValue("startDate", null);
      setValue("endDate", null);
      return;
    }
    setValue(name, data);

    if (dateAndTime) {

      var startDateTime = data.startMonth.toLocaleDateString('pt-BR').split('/')[2] + '-' + data.startMonth.toLocaleDateString('pt-BR').split('/')[1] + '-' + data.startMonth.toLocaleDateString('pt-BR').split('/')[0] + 'T' + data.startMonth.toLocaleTimeString('pt-BR').split(':')[0] + ':' +  data.startMonth.toLocaleTimeString('pt-BR').split(':')[1]
      var endDateTime = data.endMonth.toLocaleDateString('pt-BR').split('/')[2] + '-' + data.endMonth.toLocaleDateString('pt-BR').split('/')[1] + '-' + data.endMonth.toLocaleDateString('pt-BR').split('/')[0] + 'T' + data.endMonth.toLocaleTimeString('pt-BR').split(':')[0] + ':' +  data.endMonth.toLocaleTimeString('pt-BR').split(':')[1]
      
      setValue("startDate", startDateTime)
      setValue("endDate", endDateTime)
    }
    else {
      setValue("startDate", format(new Date(data.startMonth), "yyyy-MM-dd"))
      setValue("endDate", format(new Date(data.endMonth), "yyyy-MM-dd"))
    }
  }

  return (
    <Grid container spacing={1}>
      <Grid item xs={2}>
        <Select 
          label={label} 
          name={name}
          control={control} 
          options={list}
          multiline={multiple}
          disabled={disabled}
          onChange={onChangeRef}
          style={style ? style : {width: '100%'}}/>
      </Grid>
      
      <Grid item xs={2}>
        <DateField
          label={tGeneral("startDate")} 
          id="startDate"
          name="startDate" 
          control={control} 
          InputLabelProps={{shrink:true}}
          fullWidth 
          disabled={!enablePeriod}
          dateAndTime={dateAndTime} /> 
      </Grid>

      <Grid item xs={2}>
        <DateField
          label={tGeneral("endDate")} 
          id="endDate"
          name="endDate" 
          control={control} 
          InputLabelProps={{shrink:true}}
          fullWidth 
          disabled={!enablePeriod}
          dateAndTime={dateAndTime} />
      </Grid>
      
    </Grid>
  )
}

export default SelectDate;
